import * as PropTypes from 'prop-types'
import { Subscribe } from 'unstated'

import {
  PageJumpState
} from '/react/library'

export const withPageJump = () => (WrappedComponent) => {
  class WithPageJump extends React.PureComponent {
    static displayName = `withPageJump(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

    shouldBlockInViewportEvents = (props) => {
      return (
        props.pageIsJumping &&
        props.pageJumpTargetId &&
        props.id !== props.pageJumpTargetId
      )
    }

    render () {
      return (
        <Subscribe to={[PageJumpState]}>
          {pageJump => {
            const allProps = {
              ...this.props,
              ...pageJump.state
            }

            return (
              <WrappedComponent
                {...allProps}
                shouldBlockInViewportEvents={() => this.shouldBlockInViewportEvents(allProps)}
                setPageJump={pageJump.setPageJump}
              />
            )
          }}
        </Subscribe>
      )
    }
  }

  WrappedComponent.propTypes = {
    ...WrappedComponent.propTypes,
    shouldBlockInViewportEvents: PropTypes.func.isRequired,
    pageHasJumpedToPosition: PropTypes.number,
    pageIsJumping: PropTypes.bool.isRequired,
    pageJumpTargetId: PropTypes.string,
  }

  return WithPageJump
}
